import { redirect, type RouteObject } from 'react-router-dom';
import { RootLayout, rootLoader, RootErrorBoundary } from './routes/root';
import { HomePage } from './routes/home';
import { ConnectPage, connectLoader, ConnectErrorBoundary } from './routes/connect';
import { InstallRoute } from './routes/install';
import { VaultLayout } from './routes/vault-layout';
// Dev-only Phase 0 gate harness. Vite's `import.meta.env.DEV` guard below is
// statically analyzable, so this import (and the whole module) is tree-shaken
// out of production builds even though it's imported unconditionally here.
import { Phase0GatePage } from './routes/phase0-gate';

// Excluded from prod bundles: registration is gated on `import.meta.env.DEV`,
// so the route (and Phase0GatePage) never reaches a production build.
const devOnlyRoutes: RouteObject[] = import.meta.env.DEV
  ? [{ path: 'dev/phase0-gate', element: <Phase0GatePage /> }]
  : [];

// The route table, separate from `createBrowserRouter` (see router.tsx) so it
// can be asserted in unit tests without instantiating a browser router — which
// kicks off a navigation whose fetch AbortSignal Node's undici rejects.
export const routeConfig: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    loader: rootLoader,
    errorElement: <RootErrorBoundary />,
    children: [
      {
        path: 'connect',
        element: <ConnectPage />,
        loader: connectLoader,
        errorElement: <ConnectErrorBoundary />,
      },
      ...devOnlyRoutes,
      {
        element: <VaultLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'install/:agentId', element: <InstallRoute /> },
        ],
      },
      // Billing moved from its own route into an anchored section of the
      // one-scroll home (2026-07-22 product decision) — keep old deep links
      // working by bouncing to home instead of 404ing.
      { path: 'billing', loader: () => redirect('/') },
      { path: '*', loader: () => redirect('/') },
    ],
  },
];
